module.exports = __webpack_public_path__ + "static/spaceship-afc3ca0eeab2cf1eb72923f5226092fc.mp3";